import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const SITE_NAME = "It's IT";
const DEFAULT_DESCRIPTION = "It's IT specializes in websites and web content management systems for small businesses and non-profits. Vibe Coding – Smarter, Faster Web Solutions.";
const DEFAULT_IMAGE = "https://itsittech.com/og-share.png";
const CANONICAL_BASE = "https://itsittech.com";

export const SEO = ({
  title,
  description = DEFAULT_DESCRIPTION,
  image = DEFAULT_IMAGE,
  url,
  type = "website",
  keywords = "web development, website design, CMS, content management, small business, non-profit, vibe coding",
  noIndex = false,
}) => {
  const location = useLocation();
  const pageTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
  // Always use production canonical URL with clean path
  const path = url || location.pathname;
  const cleanPath = path === "/" ? "" : path.replace(/\/+$/, "");
  const canonicalUrl = `${CANONICAL_BASE}${cleanPath}`;
  const imageUrl = image.startsWith("http") ? image : `${CANONICAL_BASE}${image}`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{pageTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:site_name" content={SITE_NAME} />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={canonicalUrl} />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />

      {/* Additional SEO */}
      <link rel="canonical" href={canonicalUrl} />
      <meta name="author" content={SITE_NAME} />
    </Helmet>
  );
};

export default SEO;
